<template>
    <div>
        <b-card no-body>
            <b-alert variant="primary" show style="display: inline-block; vertical-align: top;">
                <div style="display: inline-block; vertical-align: top;">
                    <div>DATES</div>
                    <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                    ></date-picker>
                </div>


                <div style="display: inline-block; vertical-align: top;">
                     <div>&nbsp;</div>
                    <b-button variant="success" style="display: inline-block; padding: 3px;" @click="fetch_init">SEARCH</b-button>
                </div>

                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin') && (items.length > 0) ">
                    <div>SALE LOCATION</div>
                    <b-form-select :options="packet.locations" v-model="picked_location" style="width: 200px;"></b-form-select>
                </div>
            </b-alert>

            <b-card-text style="padding-left: 15px; gap: 5px;" class="d-flex flex-wrap">
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='today'" @click="set_dates('today')">TODAY</b-button>
                <b-button size="sm" variant="outline-dark"  :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">YESTERDAY</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">THIS WEEK</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">LAST WEEK</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">THIS MONTH</b-button>
                <b-button size="sm" variant="outline-dark"  :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">LAST MONTH</b-button>
            </b-card-text>

            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" style="margin-top: 10px; overflow: scroll;">
                    <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" style="min-width: 100px; width: 100px;" @click="sortby('created_ts')">
                                    DATE
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px; width: 120px;" @click="sortby('invoice_id')">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px; width: 150px;" @click="sortby('locsub')">
                                    LOCATION
                                </td>
                                <td class="ipt_tdhr" style="min-width: 200px; width: 250px;" @click="sortby('product_name')">
                                    ITEM DESC
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px; width: 120px;" @click="sortby('product_sku')">
                                    ITEM SKU
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px; width: 120px;" @click="sortby('state')">
                                    STATE
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px; width: 120px;" @click="sortby('state')">
                                    IMAGE
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                  <td class="ipt_tdhr header"></td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="item,idx in filter" v-bind:key="idx">
                                <td class="ipt_tdhr non-header">
                                    {{item.created_ts}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <a
                                        href="#"
                                        @click.prevent="goToSale(item.invoice_id)"
                                        class="invoice-link"
                                        :title="'View sale details for ' + item.invoice_id"
                                    >
                                        {{item.invoice_id}}
                                    </a>
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{packet.locsubsdict[item.locsub]}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{item.product_name}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{item.product_sku}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <b-form-select
                                        size="sm"
                                        :style="{background: get_background(item)}"
                                        :options="getStateOptions(item)" 
                                        v-model="item.state"
                                        @change="update_return_item_state(item)"
                                        :disabled="!canEditState(item)"
                                    ></b-form-select>
                                </td>
                                  <td class="ipt_tdhr non-header"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert show variant="warning">NO RETURNS FOUND</b-alert>
                </div>
            </b-overlay>
        </b-card>

        <!-- Return Details Modal -->
        <b-modal v-model="showReturnModal" size="lg" title="Return Item Details" hide-footer>
            <div v-if="selectedReturn">
                <b-row>
                    <b-col md="6">
                        <p><strong>Invoice #:</strong> {{ selectedReturn.invoice_id }}</p>
                        <p><strong>Customer:</strong> {{ selectedReturn.customer }}</p>
                        <p><strong>Return Date:</strong> {{ selectedReturn.created_ts }}</p>
                        <p><strong>Salesperson:</strong> {{ selectedReturn.username }}</p>
                    </b-col>
                    <b-col md="6">
                        <p><strong>Product:</strong> {{ selectedReturn.product_name }}</p>
                        <p><strong>SKU:</strong> {{ selectedReturn.product_sku }}</p>
                        <p><strong>Return Qty:</strong> {{ selectedReturn.return_quantity }}</p>
                        <p><strong>State:</strong> 
                            <b-badge :variant="getStateVariant(selectedReturn.state)">
                                {{ getStateText(selectedReturn.state) }}
                            </b-badge>
                        </p>
                    </b-col>
                </b-row>
                
                <b-card header="Return Information" class="mt-3">
                    <b-row>
                        <b-col md="6">
                            <p><strong>Unit Price:</strong> ${{ parseFloat(selectedReturn.selling_price || 0).toFixed(2) }}</p>
                            <p><strong>Total Amount:</strong> ${{ parseFloat(selectedReturn.total_amount || 0).toFixed(2) }}</p>
                        </b-col>
                        <b-col md="6">
                            <p><strong>Available Credit:</strong> ${{ parseFloat(selectedReturn.available_credit_value || 0).toFixed(2) }}</p>
                            <p><strong>Processed By:</strong> {{ selectedReturn.created_by }}</p>
                        </b-col>
                    </b-row>
                    
                    <b-form-group label="Reason for Return" class="mt-3">
                        <b-form-textarea
                            :value="selectedReturn.reason"
                            rows="3"
                            readonly
                            plaintext
                        ></b-form-textarea>
                    </b-form-group>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import moment from 'moment';
    import global_vars from '@/utilities/global_vars';
    import Requestor from '@/utilities/Requestor';

    export default {
        name: "ReturnMerchandise",
        components: {DatePicker},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                date_range: [],
                picked_date_range: null,
                search_txt: '',
                sort_asc: false,
                users: [],
                usersdict: {},
                picked_user: null,
                picked_location: null,
                picked_created_by: null,
                showReturnModal: false,
                selectedReturn: null
            }
        },
        computed: {
            filter: function(){
                let that = this;
                let filtered = this.items.filter(function(d){
                    return (
                        ((that.picked_user) ? d.username == that.picked_user : true ) &&
                        ((that.picked_location) ? d.location_id == that.picked_location : true ) &&
                        ((that.picked_created_by) ? d.created_by == that.picked_created_by : true ) &&
                        ((that.search_txt) ? 
                            d.invoice_id.toLowerCase().includes(that.search_txt.toLowerCase()) ||
                            d.customer.toLowerCase().includes(that.search_txt.toLowerCase()) ||
                            d.username.toLowerCase().includes(that.search_txt.toLowerCase()) ||
                            d.product_name.toLowerCase().includes(that.search_txt.toLowerCase()) ||
                            d.product_sku.toLowerCase().includes(that.search_txt.toLowerCase())
                        : true)
                    );
                });

                return filtered;
            }
        },
        methods: {
            getStateOptions(item) {
                const currentState = parseInt(item.state);
                const stateOptions = [
                    { value: 32, text: 'CANCELLED' },
                    { value: -33, text: 'RETURNED' },
                    { value: 33, text: 'RECEIVED TO RETURN MERCHANDISE' },
                    { value: 2, text: 'SHIPPED' },
                    { value: 3, text: 'CANCELLED' }
                ];

                // If current state is -33 (RETURNED), only allow transition to 33 (RECEIVED)
                if (currentState === -33) {
                    return stateOptions.filter(option => 
                        option.value === -33 || option.value === 33
                    );
                }
                
                // If current state is 33 (RECEIVED), only show RECEIVED (disabled)
                if (currentState === 33) {
                    return stateOptions.filter(option => option.value === 33)
                        .map(option => ({ ...option, disabled: true }));
                }

                // For other states, return all options but disable based on business rules
                return stateOptions.map(option => {
                    if (option.value === currentState) {
                        return option;
                    }
                    // Add business logic here for other state transitions if needed
                    return { ...option, disabled: true };
                });
            },

            canEditState(item) {
                const currentState = parseInt(item.state);
                // Only allow editing if state is -33 (RETURNED) to transition to 33 (RECEIVED)
                return currentState === -33;
            },

            get_background(item) {
                const state = parseInt(item.state);
                switch(state) {
                    case 0: return 'lightgreen'; // DELIVERED
                    case 33: return 'lightblue'; // RECEIVED
                    case -33: return 'lightyellow'; // RETURNED
                    case 2: return 'lightcoral'; // SHIPPED
                    case 3: return 'lightgray'; // CANCELLED
                    case 32: return 'lightgray'; // CANCELLED
                    default: return 'white';
                }
            },

            update_return_item_state(item) {
                let path = "/api/sales/update_invoice_item_state/";
                let that = this;

                // Store the current state before changing it
                let currentState = item.state;

                let data = {
                    invoice_id: item.invoice_id, 
                    itemid: item.itemid, 
                    state: item.state, 
                    changed_by: this.packet.userDetails.username,
                    product_sku: item.product_sku, 
                    quantity: item.return_quantity,
                    current_state: currentState
                };

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        // Revert the state change in UI if there was an error
                        that.fetch_init();
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating return item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        // Refresh the data to get updated states
                        that.fetch_init();
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating return item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    // Revert the state change in UI if there was an error
                    that.fetch_init();
                }
                
                Requestor.postAsync(path, data, s, f);
            },

            getStateVariant(state) {
                switch(parseInt(state)) {
                    case 0: return 'success'; // Delivered
                    case 33: return 'info'; // Received
                    case -33: return 'warning'; // Returned
                    case 2: return 'primary'; // Shipped
                    case 3: return 'danger'; // Cancelled
                    case 32: return 'danger'; // Cancelled
                    default: return 'secondary';
                }
            },

            getStateText(state) {
                switch(parseInt(state)) {
                    case -33: return 'RETURNED';
                    case 33: return 'RECEIVED';
                    case 0: return 'DELIVERED';
                    case 2: return 'SHIPPED';
                    case 3: return 'CANCELLED';
                    case 32: return 'CANCELLED';
                    default: return 'UNKNOWN';
                }
            },

            viewReturnDetails(item) {
                this.selectedReturn = item;
                this.showReturnModal = true;
            },

            goToSale: function(invoiceId) {
                this.$router.push("/sales/viewsale/" + invoiceId + "/");
            },

            allowed: function(item) {
                let status = true;

                if (this.picked_user == null && this.picked_location == null){
                    status = true
                }

                if (this.picked_user != null && this.picked_location == null){
                    if (item.username == this.picked_user){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user == null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user != null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        if (item.username == this.picked_user){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false
                    }
                }
                return status
            },

            total: function(key){
                let that = this;
                let out = this.filter.filter(function(d){return that.allowed(d) == true});
                let total_val = 0.0;
                for (var i=0; i<out.length; i++){
                    total_val += ( parseFloat(out[i][key]) || 0.0);
                }
                return total_val
            },

            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");
                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }

                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;
                    this.fetch_init()
                }
            },

            fetch_init: function(){
                let dates = this.date_range;
                let that = this;
                
                let data = {
                    username: this.packet.userDetails.username, 
                    location_id: (this.packet.userDetails.properties.location_id || null),
                    search_txt: this.search_txt
                }
                
                // Manually build dates array for GET request
                if (dates && dates.length >= 2) {
                    data['dates[0]'] = dates[0];
                    data['dates[1]'] = dates[1];
                }
                
                let path = "/api/sales/list_return_items/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                this.items = [];
                
                Requestor.getAsyncP(path, data, this, s, f);
            },

            fetch_users_list: function(){
                let data = {userrole: this.packet.userDetails.userrole, user_id: this.packet.userDetails.id};
                let that = this;
                let path = "/api/user/get_my_users_list/"
                let s = function(response) {
                    if (response.data.result){
                        that.users = response.data.result;

                        for (var i=0; i<that.users.length; i++){
                            that.usersdict[that.users[i].value] = true;
                        }

                        that.users.splice(0, 0, {value: null, text: "ALL"});
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.getAsyncP(path, data, this, s, f);
            },

            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },

        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            if (this.packet.userDetails.userrole == "admin" || this.packet.userDetails.userrole == "locationadmin"){
                this.fetch_users_list();
            }
        }
    }
</script>

<style scoped>
    .invoice-link {
        color: #007bff;
        text-decoration: underline;
        cursor: pointer;
    }

    .invoice-link:hover {
        color: #0056b3;
        text-decoration: none;
    }

    .header {
        font-size: 13px;
    }

    .non-header {
        font-weight: normal;
        font-size: 13px;
        background: beige;
        font-family: roboto;
    }

    .srr {
        font-size: 11px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    .ipt_tdhr {
        padding: 8px;
        border: 1px solid #ddd;
        text-align: center;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/Sales/ReturnMerchandise.vue